import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyMerchantState } from '../reducers';
export const getMerchantState = createSelector(
  getDragonflyMerchantState,
  (state) => state?.merchantSummary,
);

export const getCouponsetsPanelStatus = createSelector(
  getMerchantState,
  (state) => state?.couponsetsExpansionPanel,
);

export const getStoresPanelStatus = createSelector(
  getMerchantState,
  (state) => state?.storesExpansionPanel,
);

export const getCompanyName = createSelector(getMerchantState, (state) => state?.companyName);

export const getWebsiteURL = createSelector(getMerchantState, (state) => state?.websiteURL);

export const getMemberSince = createSelector(getMerchantState, (state) => state?.memberSince);

export const getOfficialBrandName = createSelector(
  getMerchantState,
  (state) => state?.officialBrandName,
);

export const getVATNumber = createSelector(getMerchantState, (state) => state?.vatNumber);

export const getQivosID = createSelector(getMerchantState, (state) => state?.qivosID);

export const getSubscriptionPlan = createSelector(
  getMerchantState,
  (state) => state?.subscriptionPlan,
);

export const getMerchantActive = createSelector(getMerchantState, (state) => state?.active);

export const getMerchantInactive = createSelector(getMerchantState, (state) => !state?.active);

export const getTotalCoupons = createSelector(getMerchantState, (state) => state?.totalCoupons);

export const getAvailableCoupons = createSelector(
  getMerchantState,
  (state) => state?.availableCoupons,
);

export const getGivenCoupons = createSelector(getMerchantState, (state) => state?.givenCoupons);

export const getStores = createSelector(getMerchantState, (state) => state?.stores);

export const getStoresFilter = createSelector(getMerchantState, (state) => state?.storesFilter);

export const getCouponsets = createSelector(getMerchantState, (state) => state?.couponsets);

export const getCouponSet = createSelector(getMerchantState, (state) => state?.couponSet);

export const getCanDeactivateMerchant = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('merchants.deactivate') ? false : true,
);

export const getSidenavStatus = createSelector(getMerchantState, (state) => state?.sideNavOpened);
